export const getBearerToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  if (!sessionToken) return '';
  const raw = sessionToken.trim().replace(/^Bearer\s+/i, '');
  return raw ? `Bearer ${raw}` : '';
};

export const storeSessionToken = (token) => {
  if (!token) return;
  const raw = String(token).trim().replace(/^Bearer\s+/i, '');
  if (raw) {
    sessionStorage.setItem('sessionToken', raw);
  }
};
